import { State } from '@meraki-internal/state';

interface IFullScreenOverlayState {
    activeOverlayIds: string[];
}

/**
 * Tracks which full-screen overlays (welcome slides, intro screen, etc.) are
 * currently covering the underlying page. Used by useTrackOnVisible so that
 * "page opened" events don't fire while the user is looking at an overlay.
 */
export class FullScreenOverlayState extends State<IFullScreenOverlayState> {
    constructor() {
        super({ activeOverlayIds: [] });
    }

    open = (id: string) => {
        if (this.state.activeOverlayIds.includes(id)) {
            return;
        }
        this.setState({ activeOverlayIds: [...this.state.activeOverlayIds, id] });
    };

    close = (id: string) => {
        if (!this.state.activeOverlayIds.includes(id)) {
            return;
        }
        this.setState({ activeOverlayIds: this.state.activeOverlayIds.filter(o => o !== id) });
    };

    hasActiveOverlay = (): boolean => {
        return this.state.activeOverlayIds.length > 0;
    };
}
